(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rrc-motion-hero"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('rrc-motion-hero')){
  customElements.define('rrc-motion-hero',class extends HTMLElement{
    connectedCallback(){
      const video=this.querySelector('video'),button=this.querySelector('button');
      if(!video||!button||this.initialised)return;
      this.initialised=true;
      const update=()=>{button.textContent=video.paused?'Play':'Pause';button.setAttribute('aria-label',video.paused?'Play video':'Pause video');};
      if(window.matchMedia('(prefers-reduced-motion: reduce)').matches){video.autoplay=false;video.pause();}
      video.addEventListener('play',update);video.addEventListener('pause',update);
      button.addEventListener('click',()=>{if(video.paused){video.play().catch(update);}else{video.pause();}});
      update();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
